/* eslint-disable */
/**
 * Convert timzone offset string to minutes
 * @param {string} offset The timezone offset (ex. +8:00 or -12:00)
 * @returns {number} The offset in minutes
 */
const offsetToMinutes = (offset) => {
  const [h, m] = offset.split(/[.:]/);
  const hours = Number.parseInt(h, 10);
  const minutes = Number.parseInt(m, 10);
  const isNegative = hours < 0;
  return Math.abs(hours) * (isNegative ? 1 : -1) * 60 + (isNegative ? minutes : -minutes);
};

export default offsetToMinutes;
